@if (viewInitd$ | async) {
	@if (selectedItem) {
		<nha-popup [isClick]="true" contentClass="jump-to-menu">
			<div class="current-selection dark-theme" nhaTest="current-selection" popup-target>
				<button mat-button nhaTest="switch-selection">
					<mat-icon>subject</mat-icon>
					{{ jumpToMenuConfig.html | templateFunc: [selectedItem] }}
				</button>
			</div>
			<div popup-content class="menu-list">
				<nha-simple-list [config]="menuListConfig" [items]="items">
					<div pre-list>
						<div class="is-current" nhaTest="current-item">
							<a (click)="closePopUp()" [routerLink]="jumpToMenuConfig.link(selectedItem)">
								<mat-icon>arrow_forward</mat-icon>
								<ng-template
									[ngTemplateOutlet]="jumpToMenuConfig.customMenuItemTemplate || itemInfoTemplate"
									[ngTemplateOutletContext]="{ item: selectedItem }"
								></ng-template>
							</a>
						</div>
					</div>
				</nha-simple-list>
			</div>
		</nha-popup>
	}
}

<ng-template #itemInfoTemplate let-item="item">
	<span class="item" nhaTest="jump-to-menu-item">
		{{ jumpToMenuConfig.html | templateFunc: [item] }}
	</span>
</ng-template>
